import { baseApi } from '../../../core/baseApi';
import type { CurrentUsageResponse, UsageHistoryItem } from '../types';
import type { ApiResponse } from '../../../patterns/crud';

export const usageApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    // Get current period usage
    getCurrentUsage: builder.query<CurrentUsageResponse, void>({
      query: () => '/billing/usage',
      transformResponse: (response: ApiResponse<CurrentUsageResponse>) => response.data,
      providesTags: ['Usage'],
    }),

    // Get usage history
    getUsageHistory: builder.query<UsageHistoryItem[], number | void>({
      query: (limit) => ({
        url: '/billing/usage/history',
        params: limit ? { limit } : {},
      }),
      transformResponse: (response: ApiResponse<UsageHistoryItem[]>) => response.data,
      providesTags: ['UsageHistory'],
    }),
  }),
});

export const {
  useGetCurrentUsageQuery,
  useGetUsageHistoryQuery,
} = usageApi;
